import React from "react";
import ufuk from "../components/photos/ufuk.jpg";

export default function Header() {
  return (
    <header className="header">
      <div>
        <img src={ufuk} alt="Profile" className="avatar" />
      </div>

      <div>
        <h3>Hey, I'm Ufuk DEMİREL.</h3>
      </div>

      <div>
        <p>
          I am a Web & Shopify Developer, Frontend Developer. <br />
          Living with code is good for me.
        </p>
      </div>

      <div className="icons">
        <div className="tooltip">
          <img width="22" height="22" src="https://img.icons8.com/ios-filled/50/twitterx--v1.png" alt="twitterx--v1" />
          <span className="tooltiptext">Twitter/X</span>
        </div>

        <a href="https://www.youtube.com/@demrelufuk" target='_blank' rel="noreferrer">
          <div className="tooltip">
            <img width="28" height="28" src="https://img.icons8.com/ios-filled/50/youtube-play.png" alt="youtube-play"/>
            <span className="tooltiptext">YouTube</span>
          </div>
        </a>

        <a href="https://mail.google.com/mail/u/0/?pli=1#inbox" target='_blank' rel="noreferrer">
          <div className="tooltip">
            <img
              width="22"
              height="22"
              src="https://img.icons8.com/ios-filled/50/gmail-new.png"
              alt="gmail-new"
            />
            <span className="tooltiptext">Gmail</span>
          </div>
        </a>

        <a href="https://www.linkedin.com/in/ufuk-demirel-1a6058389" target='_blank' rel="noreferrer">
          <div className="tooltip">
            <img
              width="22"
              height="22"
              src="https://img.icons8.com/ios-filled/50/linkedin.png"
              alt="linkedin"
            />
            <span className="tooltiptext">LinkedIn</span>
          </div>
        </a>

        <a href="https://github.com/UfukDemrel" target='_blank' rel="noreferrer">
          <div className="tooltip">
            <img width="22" height="22" src="https://img.icons8.com/ios-filled/50/github.png" alt="github" />
            <span className="tooltiptext">Github</span>
          </div>
        </a>

        <a href="https://www.udemy.com/user/ufuk-demirel-6/" target='_blank' rel="noreferrer">
          <div className="tooltip">
            <img width="22" height="22" src="https://img.icons8.com/external-tal-revivo-bold-tal-revivo/24/external-udemycom-is-an-online-learning-and-teaching-platform-logo-bold-tal-revivo.png" alt="external-udemycom-is-an-online-learning-and-teaching-platform-logo-bold-tal-revivo" />
            <span className="tooltiptext">Udemy</span>
          </div>
        </a>
      </div>
    </header>
  );
}
